import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import type { Diet, ProfileFormData, Shirt } from './types';

const SHIRT_SIZES: Shirt[] = ['S', 'M', 'L', 'XL'];
const DIETS: Diet[] = ['omnivora', 'vegetariana', 'vegana'];
const DIET_ICONS: Record<Diet, string> = {
  omnivora: '🍖',
  vegetariana: '⚪',
  vegana: '🌱',
};

interface Props {
  data: ProfileFormData;
  onChange: (patch: Partial<ProfileFormData>) => void;
}

export function ConsiderationsStep({ data, onChange }: Props) {
  return (
    <div className="space-y-8">
      <h2 className="font-bold text-3xl">alguna consideración?</h2>

      <div className="space-y-4">
        <div className="block font-semibold text-sm">
          qué tamaño de playera usas? 👕 *
        </div>
        <div className="space-y-2">
          {SHIRT_SIZES.map((size) => (
            <label
              key={size}
              className={cn(
                'flex cursor-pointer items-center gap-3 rounded-lg border-2 p-3 transition-colors',
                data.shirtSize === size
                  ? 'border-primary bg-primary/10'
                  : 'border-border bg-transparent',
              )}
            >
              <input
                type="radio"
                name="shirtSize"
                value={size}
                checked={data.shirtSize === size}
                onChange={() => onChange({ shirtSize: size })}
                className="sr-only"
              />
              <span className="font-semibold">{size}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <div className="block font-semibold text-sm">que dieta tienes? *</div>
        <div className="space-y-2">
          {DIETS.map((diet) => (
            <label
              key={diet}
              className={cn(
                'flex cursor-pointer items-center gap-3 rounded-lg border-2 p-3 transition-colors',
                data.diet === diet
                  ? 'border-primary bg-primary/10'
                  : 'border-border bg-transparent',
              )}
            >
              <input
                type="radio"
                name="diet"
                value={diet}
                checked={data.diet === diet}
                onChange={() => onChange({ diet })}
                className="sr-only"
              />
              <span className="text-lg">{DIET_ICONS[diet]}</span>
              <span className="font-semibold">{diet}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <div className="block font-semibold text-sm">
          alergias alimenticias?
        </div>
        <p className="text-secondary-foreground text-xs">
          deja en blanco si no tienes
        </p>
        <Input
          type="text"
          value={data.allergies}
          onChange={(e) => onChange({ allergies: e.target.value })}
          className="border-border bg-card text-foreground"
        />
      </div>

      <div className="space-y-4">
        <div className="block font-semibold text-sm">dificultad física?</div>
        <p className="text-secondary-foreground text-xs">
          deja en blanco si no tienes
        </p>
        <Input
          type="text"
          value={data.physicalIssues}
          onChange={(e) => onChange({ physicalIssues: e.target.value })}
          className="border-border bg-card text-foreground"
        />
      </div>

      <div className="space-y-4">
        <label
          className={cn(
            'flex cursor-pointer items-start gap-3 rounded-lg border-2 p-4 transition-colors',
            data.shareInfoWithSponsors
              ? 'border-primary bg-primary/10'
              : 'border-border bg-transparent',
          )}
        >
          <input
            type="checkbox"
            checked={data.shareInfoWithSponsors}
            onChange={(e) =>
              onChange({ shareInfoWithSponsors: e.target.checked })
            }
            className="sr-only"
          />
          <div className="flex-1">
            <div className="font-semibold">compartir info</div>
            <p className="text-secondary-foreground text-sm">
              quiero compartir mi info de contacto con los sponsors principales
              del evento
            </p>
          </div>
        </label>
      </div>
    </div>
  );
}
